import { optionTitle_notificationTiming } from './NotificationTimingOption.locstring.json';
import { LazyModule } from 'owa-bundling';
import { createLazyOption, LazyOption } from 'owa-options-core';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const AccessibilityOption: LazyOption = createLazyOption(
    {
        key: 'notificationTimingOption',
        titleStringKey: optionTitle_notificationTiming,
        searchTermsStringKey: optionTitle_notificationTiming,
    },
    lazyFullModule,
    m => m.default
);
export default AccessibilityOption;
